import { isEqual, take } from 'lodash-es';
export function arraysEqual(array1, array2, itemComparator = isEqual) {
    if (array1.length !== array2.length) {
        return false;
    }
    for (let i = 0; i < array1.length; i += 1) {
        if (!itemComparator(array1[i], array2[i])) {
            return false;
        }
    }
    return true;
}
export function arrayStartsWith(array, subarray) {
    return isEqual(take(array, subarray.length), subarray);
}
export function findSubArray(array, subarray, itemComparator = isEqual) {
    if (subarray.length > array.length) {
        return null;
    }
    for (let i = 0; i < array.length - subarray.length + 1; i += 1) {
        if (arraysEqual(array.slice(i, i + subarray.length), subarray, itemComparator)) {
            return i;
        }
    }
    return null;
}
